import script from "./CustomCssAreaField.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCssAreaField.vue?vue&type=script&setup=true&lang=js"

import "./CustomCssAreaField.vue?vue&type=style&index=0&id=0acdaf58&lang=css"

const __exports__ = script;

export default __exports__